/* Copyright (c) 2018 Scaper */

import * as React from "react";

import "./brandName.scss";

export class BrandName extends React.Component {
    public render() {
        return (
            <div className="scpr-BrandName">
                Scaper
            </div>
        );
    }
}
